import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

const EditUserModal = ({ open, handleClose, userData, handleSave }) => {
    const [formData, setFormData] = useState({
        username: '',
        name: '',
        password: '',
        role: 'user'
    });

    useEffect(() => {
        if (userData) {
            setFormData({
                username: userData.user || '',
                name: userData.name || '',
                password: '', // رمز عبور را خالی می‌گذاریم
                role: userData.role || userData.an_role || 'user'
            });
        }
    }, [userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        handleSave(formData);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ backgroundColor: '#f5f5f5', color: '#333' }}>
                ویرایش اطلاعات کاربر
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                <Grid container spacing={2} sx={{ mt: 0 }}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="نام کاربری"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            dir="rtl"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="نام و نام خانوادگی"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            dir="rtl"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="رمز عبور (خالی بگذارید تا تغییر نکند)"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            type="password"
                            variant="outlined"
                            size="small"
                            dir="rtl"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth size="small">
                            <InputLabel>نقش کاربر</InputLabel>
                            <Select
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                label="نقش کاربر"
                            >
                                <MenuItem value="user">کاربر عادی</MenuItem>
                                <MenuItem value="admin">مدیر</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button
                    onClick={handleClose}
                    variant="outlined"
                    color="error"
                    startIcon={<CloseIcon />}
                >
                    انصراف
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                >
                    ذخیره تغییرات
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditUserModal;